var packageName = "@atlassian/product-search-dialog";
var packageVersion = "15.35.0";
export var BUILD_VERSION = "".concat(packageName, "@").concat(packageVersion);